import React from "react";

import { Link } from "react-router-dom";
import { translate } from "react-i18next";
import { MenuMessageService } from './message-service';

class MenueItem extends React.Component {
  sendCloseMessage() {
    MenuMessageService.sendCloseAllMenusMessage();
  }

  render() {
    const { t } = this.props;
    return (
      <li>
        <Link
          to={this.props.to} 
          data-toggle="collapse"
          data-target=".nav-collapse"
          onMouseOver={this.sendCloseMessage}
        >
          {t(this.props.title)}
        </Link>
      </li> 
    );
  }
}

export default translate()(MenueItem);
